import React, { useEffect, useRef, useState } from "react";
import useRoom from "./useRoom";
import RecapDialog from "./RecapDialog";
import EmailTrimDialog from "./EmailTrimDialog";
import { emailFromRow } from "./RoomGroup";
import { SECTION_LABEL } from "./roomModel.mjs";
import useEscapeLayer from "../useEscape";
import "./rooms.css";

/*
 * "ADD TO ROOM ▾" ON AN EMAIL IN THE TIMELINE (AddToRoom board, A). Two ways in:
 * as written, into Our conversation (through the trim), or, for one of ours, as
 * a call recap (through the four-block preview). An email already on the room
 * says where instead: "On the room · Our conversation".
 *
 * Props: row (the timeline's raw row: id, body, title, direction, holders,
 *        sender), company { id, name }
 */
export default function AddToRoomMenu({ row, company }) {
  const { data } = useRoom(company && company.id);
  const [open, setOpen] = useState(false);
  const [dialog, setDialog] = useState(null);
  const ref = useRef(null);
  useEscapeLayer(open, () => setOpen(false));
  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", away);
    return () => document.removeEventListener("mousedown", away);
  }, [open]);

  if (!company || !company.id || !row || !String(row.body || "").trim()) return null;
  const on = (data && data.on_room && data.on_room[row.id]) || [];
  const outbound = (row.direction || (row.metadata || {}).direction) === "outbound";
  const host = (data && data.host) || "Gabriel";

  return (
    <span className="rm" style={{ display: "inline-flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      {on.length > 0 && <span className="rm-pill">On the room · {on.map((s) => SECTION_LABEL[s]).join(", ")}</span>}
      <span className="rm-menuwrap" ref={ref}>
        <button type="button" className="rm-btn rm-btn--dark rm-btn--sm" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
          Add to room ▾
        </button>
        {open && (
          <div className="rm-menu" role="menu" aria-label="Add to room">
            <button
              type="button"
              role="menuitem"
              className="rm-menu__item"
              onClick={() => {
                setOpen(false);
                setDialog("trim");
              }}
            >
              <b>{on.includes("conversation") ? "Edit in Our conversation" : "Add to Our conversation"}</b>
              <span>Shows as written: sender, date, subject, body</span>
            </button>
            {outbound && (
              <button
                type="button"
                role="menuitem"
                className="rm-menu__item"
                onClick={() => {
                  setOpen(false);
                  setDialog("recap");
                }}
              >
                <b>Add as a Call recap…</b>
                <span>For a post-call follow-up. Preview the four blocks first</span>
              </button>
            )}
          </div>
        )}
      </span>
      {dialog === "trim" && <EmailTrimDialog companyId={company.id} companyName={company.name} email={emailFromRow(row, host)} onClose={() => setDialog(null)} />}
      {dialog === "recap" && <RecapDialog companyId={company.id} companyName={company.name} activityId={row.id} onClose={() => setDialog(null)} />}
    </span>
  );
}
